import * as React from 'react'

import { cn } from '~/styled'
import { overrideStyledVariantValue } from '~/utilities/override-styled-variant-value/overrideStyledVariantValue'

import { Button } from '../../button/Button'
import { useBannerContext } from '../BannerContext'

export const BannerSlimButton = ({
  className,
  ...props
}: React.ComponentProps<typeof Button>) => {
  const { emphasis, size } = useBannerContext()

  const fullWidth = React.useMemo(
    () => overrideStyledVariantValue(size, (s) => s === 'sm'),
    [size]
  )

  return (
    <Button
      size="md"
      fullWidth={fullWidth}
      theme={emphasis === 'bold' ? 'neutral' : 'primary'}
      {...props}
      className={cn('ml-auto', className)}
    />
  )
}

BannerSlimButton.displayName = 'BannerSlimButton'
